export enum UserFeatureCode {
    DataUiWeb = 'data-ui-web',
    WysiwygEditor = 'wysiwyg-editor',
}

export enum UserFeatureSetting {
    'data-ui-web' = 'data_ui_web',
    'wysiwyg-editor' = 'wysiwyg_editor',
}

export enum UserFeatureStatus {
    PendingEnable = 'PENDING_ENABLE',
    Enabled = 'ENABLED',
    PendingDisable = 'PENDING_DISABLE',
    Disabled = 'DISABLED',
}

export interface UserFeature {
    id?: number;
    code: UserFeatureCode;
    status: UserFeatureStatus;
}
